import * as XLSX from 'xlsx';
import { TFunction } from 'i18next';
import moment from 'moment';
import {
    IClientTimeToHireJobData,
    IClientTimeToHireComparisonData,
} from '../interfaces/reports.interfaces';
import {
    getJobMetricChartData,
    getComparisonChartData,
} from './reportChart.utils';

const sanitizeFileName = (value: string): string =>
    value.replace(/[\\/:*?"<>|]/g, '_').trim() || 'export';

const today = (): string => moment().format('YYYY-MM-DD');

export const exportJobMetricsToExcel = (
    data: IClientTimeToHireJobData,
    t: TFunction
): void => {
    const jobHeader = t(
        'reportsPage.timeToHireReport.jobSpecific.tableHeaderJob'
    );
    const stepHeader = t(
        'reportsPage.timeToHireReport.jobSpecific.tableHeaderStep'
    );
    const averageTimeHeader = t(
        'reportsPage.timeToHireReport.jobSpecific.tableHeaderAverageTime'
    );

    const rows = getJobMetricChartData(data, t).map((row) => ({
        [jobHeader]: data.jobTitle,
        [stepHeader]: row.name,
        [averageTimeHeader]: row.days,
    }));

    const worksheet = XLSX.utils.json_to_sheet(rows);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, 'Time to Hire');
    XLSX.writeFile(
        workbook,
        `time-to-hire_${sanitizeFileName(data.jobTitle)}_${today()}.xlsx`
    );
};

export const exportComparisonToExcel = (
    data: IClientTimeToHireComparisonData,
    t: TFunction
): void => {
    const rows = getComparisonChartData(data, t);
    const worksheet = XLSX.utils.json_to_sheet(rows);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, 'Comparison');
    XLSX.writeFile(workbook, `time-to-hire_comparison_${today()}.xlsx`);
};
